import { ICanvasEditorState } from "../../widgets/interfaces/model/index";
import { createReducers } from "../util";
import { copy, resetClipboard, updateClipboard } from "./ClipboardOperation";

/**
 * Default state for clipboard
 */
const initialState: ICanvasEditorState["clipboard"] = {
	clearOnPaste: false,
	clipboard: [],
};

/**
 * Action constants for clipboard operations
 */
export enum ClipboardActionConstants {
    COPY = "COPY",
    UPDATE_CLIPBOARD = "UPDATE_CLIPBOARD",
    RESET_CLIPBOARD = "RESET_CLIPBOARD",
}

/**
 * Clipboard reducers
 */
export const clipboard = createReducers(initialState, {
	[ClipboardActionConstants.COPY]: copy,
	[ClipboardActionConstants.UPDATE_CLIPBOARD]: updateClipboard,
	[ClipboardActionConstants.RESET_CLIPBOARD]: resetClipboard,
});
